import { useSession } from 'next-auth/react';

const SHOKWORKS_ONLY_CASE_IDS: string[] = [
	'b2b28976-8937-485b-b8e9-b4fecea002a1',
	'autopilot-safety-claims-cm1',
];

const SHOKWORKS_ONLY_CASE_TITLES: string[] = ['Autopilot Safety Claims'];

const ALLOWED_EMAILS: string[] = [
	'daicarab@gmail.com',
	'dhealey@lowey.com',
	'davidehealey@gmail.com',
	'dai_dvc@hotmail.com',
	'colmenarescdaniel@gmail.com',
	'wjlb.lv5+10@gmail.com',
	'jvalverde@valprit.com',
	'jvalverdee@valprit.com',
	'dabolitus@yahoo.com',
	'fefelepil@gmail.com',
	'bekehod106@goldlicai.com',
];

export const useInternalCaseFilter = () => {
	const session = useSession();
	const user = session.data?.user as any;
	const userEmail: string = user?.user?.email ?? user?.email ?? '';

	const canSeeInternalCases =
		userEmail.endsWith('@shokworks.io') || ALLOWED_EMAILS.includes(userEmail);

	const filterInternalCases = <
		T extends { id: string | number; title?: string }
	>(
		cases: T[]
	): T[] => {
		if (canSeeInternalCases) return cases;
		return cases.filter(
			(c) =>
				!SHOKWORKS_ONLY_CASE_IDS.includes(String(c.id)) &&
				!(c.title && SHOKWORKS_ONLY_CASE_TITLES.includes(c.title))
		);
	};

	return { canSeeInternalCases, filterInternalCases, SHOKWORKS_ONLY_CASE_IDS };
};
